/* Bilingual content for Intake Results page */

export const RESULTS_CONTENT = {
  en: {
    personalizedForYou: "Personalized for you",
    qualifyTitle: "You qualify for the following treatments",
    reviewSubtitle: "Our physician team will review your intake before processing.",
    noMatchTitle: "We couldn't find a matching program — here's what you can purchase individually:",
    bookConsultTitle: "Let's review your case with a provider",
    bookConsultSubtitle: "Our medical team would like to speak with you before recommending treatment. Booking is complimentary.",
    bookConsultButton: "Book my consultation →",
    recommendedPrograms: "Recommended programs",
    individualTreatments: "Individual treatments",
    continueToCheckout: "Continue to Checkout →",
    pricesVary: "*Prices vary by state · This is not a diagnosis.",
    addToMyPlan: "Add to my plan →",
    threemonthCommitment: "3-month commitment",
    total: "total for first 3 months",
    oneTime: "One-time purchase · No commitment",
    includes: "Includes",
    pricing: "Pricing",
    membership: "Membership",
    retail: "Retail",
    oneTimeOption: "One-time",
    mo: "/mo",
    dose: "Dose",
    strength: "Strength",
    physicianReview: "Physician review included",
    recommended: "Recommended",
    mostPopular: "Most popular",
    maximum: "Maximum",
    home: "Home",
    shop: "Shop",
    addedToCart: "added to cart",
    minimumCommitment: "3-month minimum commitment.",
    basedOnAnswers: "Based on your answers",
    bundleInclusions: {
      tirzPatientProtocol: "Tirzepatide protocol",
      tirzMaxDose: "Tirzepatide (34mg max dose)",
      nadVial: "NAD+ (1000mg vial)",
      sermorelin9mg: "Sermorelin (9mg vial)",
      sermorelin15mg: "Sermorelin (15mg vial)",
      medicalEval: "Medical evaluation + personalized dosing",
      ongoingSupervision: "Ongoing physician supervision",
    },
  },
  es: {
    personalizedForYou: "Personalizado para ti",
    qualifyTitle: "Calificas para los siguientes tratamientos",
    reviewSubtitle: "Nuestro equipo médico revisará tu registro antes de procesar.",
    noMatchTitle: "No encontramos un programa coincidente — esto es lo que puedes comprar individualmente:",
    bookConsultTitle: "Revisemos tu caso con un proveedor",
    bookConsultSubtitle: "Nuestro equipo médico desea hablar contigo antes de recomendar un tratamiento. La reserva es gratuita.",
    bookConsultButton: "Reservar mi consulta →",
    recommendedPrograms: "Programas recomendados",
    individualTreatments: "Tratamientos individuales",
    continueToCheckout: "Continuar al Pago →",
    pricesVary: "*Los precios varían por estado · Esto no es un diagnóstico.",
    addToMyPlan: "Agregar a mi plan →",
    threemonthCommitment: "Compromiso de 3 meses",
    total: "total por los primeros 3 meses",
    oneTime: "Compra única · Sin compromiso",
    includes: "Incluye",
    pricing: "Precios",
    membership: "Membresía",
    retail: "Venta directa",
    oneTimeOption: "Una vez",
    mo: "/mes",
    dose: "Dosis",
    strength: "Concentración",
    physicianReview: "Revisión médica incluida",
    recommended: "Recomendado",
    mostPopular: "Más popular",
    maximum: "Máximo",
    home: "Inicio",
    shop: "Tienda",
    addedToCart: "agregado al carrito",
    minimumCommitment: "Compromiso mínimo de 3 meses.",
    basedOnAnswers: "Según tus respuestas",
    bundleInclusions: {
      tirzPatientProtocol: "Protocolo de Tirzepatide",
      tirzMaxDose: "Tirzepatide (dosis máxima 34mg)",
      nadVial: "NAD+ (vial de 1000mg)",
      sermorelin9mg: "Sermorelina (vial de 9mg)",
      sermorelin15mg: "Sermorelina (vial de 15mg)",
      medicalEval: "Evaluación médica + dosificación personalizada",
      ongoingSupervision: "Supervisión médica continua",
    },
  },
};

export function getResultsContent(lang) {
  return RESULTS_CONTENT[lang] || RESULTS_CONTENT.en;
}
